import React, { Fragment } from 'react'
import { useListTableRow } from '@newageerp/v3.bundles.app-bundle';
import { Badges } from '@newageerp/crm-ui';
interface Props {
    fieldKey: string,
}

export default function PaymentsPspData(props: Props) {
    const { element } = useListTableRow();

    return (
        <div className='flex gap-x-2 items-center w-[50px]'>
            {!!element.paymentPsp && <Fragment>
                <img className='max-h-[15px] max-w-[50px]' src={`/payment/icons/${element.paymentPsp.pspName}.svg`} alt={element.paymentPsp.pspName} title={element.paymentPsp.pspName} />
            </Fragment>}

            {!element.paymentPsp && <Fragment>
                <img className='max-h-[15px] max-w-[50px]' src={`/payment/icons/${element.source}.svg`} alt={element.source} title={element.source} />
            </Fragment>}

            {element.paymentPsp && <Fragment>
                {element.paymentPsp.pspStatus === 'captured' && 
                <span className='text-xs bg-green-100 text-green-700 flex items-center justify-center leading-none p-2 rounded' title="Settled">S</span>}

                {element.paymentPsp.pspStatus === 'authorized' && 
                <span className='text-xs bg-yellow-100 text-yellow-700 flex items-center justify-center leading-none p-2 rounded' title="Authorized">A</span>}
                </Fragment>}
                
        </div>
    )
}